<div class="modal-header mfp-header">
    <h5 class="modal-title">{{ ProductAmount.ProductAmountID ? 'Edit' : 'Create' }} Contents</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">ID:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="ProductAmount.ProductAmountID" disabled />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Product Type:</div>
            <div class="col-12 col-md-6">
                <select class="form-select"
                        [(ngModel)]="ProductAmount.ProductType"
                        [compareWith]="CompareProductTypes"
                        (ngModelChange)="RecalculateID()"
                        [disabled]="!IsNew">
                    <option *ngFor="let productType of ProductTypeValues" [ngValue]="productType">
                        {{ productType.Name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Batch/Blend:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="ProductAmount.Batch" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Composition:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="ProductAmount.Composition" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Barrel:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control"
                       [(ngModel)]="ProductAmount.Barrel"
                       [ngbTypeahead]="BarrelSearch"
                       [inputFormatter]="FormatBarrel"
                       [resultFormatter]="FormatBarrel"
                       [editable]="false"
                />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Date Filled:</div>
            <div class="col-12 col-md-6">
                <input type="date"
                       class="form-control"
                       [ngModel]="ProductAmount.DateFilled | date:'yyyy-MM-dd'"
                       (ngModelChange)="ProductAmount.DateFilled = $event" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Gallons In:</div>
            <div class="col-12 col-md-6">
                <input type="number" class="form-control" [(ngModel)]="ProductAmount.Gallons" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Proof in BBL:</div>
            <div class="col-12 col-md-6">
                <input type="number" class="form-control" [(ngModel)]="ProductAmount.Proof" />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>